import { AiServiceSetting } from '@/features/ai_service_setting';

const AiServiceSettingPage = () => <AiServiceSetting />;

export default AiServiceSettingPage;
